import { Fragment } from 'react';

export default function FormGrid({ columns = [] }) {
  return (
    <div className='grid grid--2-cols grid--with-divider '>
      {columns.map((col, colIdx) => (
        <div key={colIdx} className='data-grid-column content-start'>
          {col.rows.map((row, rowIdx) => {
            if (row.type === 'customRow' && row.render)
              return <Fragment key={rowIdx}>{row.render()}</Fragment>;

            if (row.type === 'inline') {
              return (
                <div key={rowIdx} className='row row--between col-2'>
                  {row.items.map((item, i) => (
                    <div key={i} className='row gap-5'>
                      {item.label && <span className='label--secondary'>{item.label}</span>}
                      {item.field}
                    </div>
                  ))}
                </div>
              );
            }

            return (
              <div key={rowIdx} className='data-grid-row row'>
                <span className='label--secondary'>{row.label}</span>
                {row.field}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
